import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiVersion, ApiService } from 'src/app/services/api.service';
import { SerieModel } from '../models/serie.model';
import { Observable } from 'rxjs';

@Injectable()
export class SerieService {
    constructor(private http: HttpClient, private apiService: ApiService) {}
    
    getPorEscola({ hashEscola, hashPeriodo }): Observable<SerieModel[]> {
        return this.http.get<SerieModel[]>(
            `${this.apiService.getUrl()}/${ApiVersion}/series/${hashEscola}/${hashPeriodo}`
        );
    }
}
